export const NAMESPACE = "@@LOADING";  // 定义模块名

function createLoadingPlugin (opts={}){
  const {
    namespace = NAMESPACE,  //命名空间
    includes = [], //包含的 action type 集合
    excludes = [], //排除的 action type 集合
  } = opts;

  const SHOW = `${namespace}/SHOW`;  // 显示 mutation 同步type
  const HIDE = `${namespace}/HIDE`;  // 隐藏 mutation 同步type

  return store => {
    // console.log({...store});
    if (store.state[namespace]){
      throw new Error(`createLoadingPlugin: ${namespace} exited in current store`);
    }

    // 注册全局 loading 模块
    store.registerModule(namespace, {
      namespaced: true,
      state: () => ({
        global: false,  //定义全局loading
        effects: {},  //存储 action 的 loading 集合
      }),
      mutations: {
        SHOW(state, payload){
          state.global = true;  //显示全局 loading
          state.effects = {...state.effects, [payload]: true};  //显示当前action的 loading
        },
        HIDE(state, payload){
          state.global = false;
          state.effects = {...state.effects, [payload]: false};
        },
      },
    })

    // 订阅 action
    store.subscribeAction({
      // 派发前执行
      before(action){
        // console.log('before =>', action);
        if (onEffect(action, includes, excludes)){
          store.commit(SHOW, action.type, {root: true});
        }
      },
      // 派发后执行
      after(action){
        // console.log('after =>', action);
        if (onEffect(action, includes, excludes)){
          store.commit(HIDE, action.type, {root: true});
        }
      },
    })
  }
}

// 判断是否要执行
function onEffect({type}, includes, excludes){
  // 如果都没配置，就默认全部的 action 都添加 loading 状态
  if (includes.length === 0 && excludes.length === 0) return true;
  if (includes.length > 0) return includes.includes(type);
  return excludes.length > 0 && !excludes.includes(type);
}

export default createLoadingPlugin;